webpackJsonp([253626871324061],{

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThanksPage = function ThanksPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Thanks - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Thank you!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Talk soon',
	      _react2.default.createElement(
	        'span',
	        { role: 'img', 'aria-label': 'thanks' },
	        '\uD83D\uDE09'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      'Back to the home site.'
	    )
	  );
	};
	exports.default = ThanksPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-thanks-js-d5a3e1b52aa9d27093d6.js